//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';
import { useStore } from '../../../../store/store';
import { format } from 'date-fns';
import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import WeightChart from 'src/onboarding/components/ui/graph/Graph';
import GoalGraph from 'src/onboarding/components/ui/goalGraph/Graph';
import { getEarlyAchievableOffset } from 'src/onboarding/helpers/getEarlyAchievableOffset';
import { getAdjustedDate } from 'src/onboarding/helpers/getAdjustedDate';
import { getFullMonthName } from 'src/onboarding/helpers/getFullMonthName';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import { getMonthName } from 'src/onboarding/helpers/getMonthName';

const GoalGraphPaywall = () => {
  const idealWeight = useStore((state) => state.idealWeight);
  const when = useStore((state) => state.when);
  const weight = useStore((state) => state.weight);

  const { routeGroups: flow } = useRemoteConfig();

  const adjustedDate = getAdjustedDate(when, getEarlyAchievableOffset(when));

  const isShowNewDate = getEarlyAchievableOffset(when) !== null && flow.flat().includes('goal-2');
  return (
    <div className={styles.container}>
      <Caption className={styles.titleFirst}>{t('onboarding.personalPlan.graph.title')}</Caption>
      <Title tag='h4' className={styles.titleSecond}>
        <span>
          {idealWeight.value} {t(`onboarding.weight.${idealWeight.type}`)}
        </span>{' '}
        {t('onboarding.personalPlan.graph.by')}{' '}
        {isShowNewDate
          ? t(`onboarding.common.calendar.${getFullMonthName(adjustedDate.month)}`) +
            ' ' +
            adjustedDate.year
          : t(`onboarding.common.calendar.${getFullMonthName(when.month)}`) + ' ' + when.year}
      </Title>
      {isShowNewDate ? (
        <GoalGraph
          weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
          targetDate={when}
          differenceDate={getEarlyAchievableOffset(when)}
          targetWeight={idealWeight.value}
          unit={weight.type === 'kg' ? 'kg' : 'lbs'}
          styles
        />
      ) : (
        <WeightChart
          weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
          dateWhen={when}
          weightWhen={idealWeight.value}
          unit={weight.type === 'kg' ? 'kg' : 'lbs'}
          styles
        />
      )}
    </div>
  );
};
export default GoalGraphPaywall;
